"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiGroup = _interopRequireDefault(require("./ApiGroup"));
var _chains = require("@blockwell/chains");
class Transactions extends _ApiGroup.default {
  /**
   * Creates a new API Miner transaction, typically ether transfer.
   */
  create(network, to, value, opt = {}) {
    let data = Object.assign({}, opt, {
      network,
      to,
      value
    });
    return this.request({
      method: 'post',
      url: '/transactions',
      data
    }).then(response => response.data.data);
  }

  /**
   * List Transactions belonging to the current user.
   */
  list() {
    return this.request({
      url: '/transactions'
    }).then(response => response.data.data);
  }

  /**
   * Get a specific Transaction by its ID.
   */
  get(id) {
    return this.request({
      url: `/transactions/${id}`
    }).then(response => response.data.data);
  }

  /**
   * Gets a transaction's status including its hash, polling the server if necessary.
   */
  async getHash(id, timeout = 20000) {
    let active = true;

    // 20 second timeout to get a transaction hash
    let t = setTimeout(() => active = false, timeout);
    while (active) {
      let tx = await this.get(id);
      if (tx.transactionHash) {
        clearTimeout(t);
        return tx;
      }
      if (tx.status === 'error') {
        var _tx$error;
        clearTimeout(t);
        throw new Error(((_tx$error = tx.error) === null || _tx$error === void 0 ? void 0 : _tx$error.message) || "Unknown error occurred with transaction " + id);
      }
    }
    throw new Error("getHash timed out for transaction " + id);
  }
  getByHash(network, hash) {
    return this.request({
      url: `/transactions/hash/${(0, _chains.toChainId)(network)}/${hash}`
    }).then(response => response.data.data);
  }
}
var _default = exports.default = Transactions;
//# sourceMappingURL=Transactions.js.map